export default __webpack_public_path__ + "static/schauinsland-reisen_1_1_en-d9fd6bd9fb3473642b95d3a74d80a711.jpg";